import { BaseQueryApi, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { meMapper } from 'src/config/api/models';
import { User } from 'src/config/api/models/User';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { RootState } from 'src/modules/shared/store';

export const prepareHeaders = (
  headers: Headers,
  api: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>
) => {
  const url = window.location.href;
  headers.set('url', url);
  const sessionId = (api.getState() as RootState).auth.sessionId;
  if (sessionId) {
    headers.set('sessionId', sessionId);
  }
  const token = (api.getState() as RootState).auth.jwt;
  if (token) {
    headers.set('authorization', `Bearer ${token}`);
  }
  return headers;
};

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    requestMe: builder.mutation<User, void>({
      query: () => ({
        url: apiRoutesV2.me(),
        method: 'GET',
      }),
      transformResponse: (response: User) => meMapper(response),
    }),
    toggleImmersiveReader: builder.mutation<string[], void>({
      query: () => ({
        url: apiRoutesV2.toggleImmersiveReader(),
        method: 'PATCH',
        body: {},
      }),
    }),
  }),
});

export const { useRequestMeMutation, useToggleImmersiveReaderMutation } = authApi;
